import React, { useState, useEffect } from 'react';
import { Modal, Button, Form, Row, Col } from 'react-bootstrap';
// import axios from 'axios';
import { ServerPath } from '../../../Constant';
import { _axios } from '../../../utils/axios'; 

const EditTag = (props) => {
    const [show, setShow] = useState(false);
    const [docId, setDocId] = useState(props?.data?.doc_id);
    const [DocumentName, setDocumentName] = useState('');
    const [docStatus, setDocStatus] = useState();

    useEffect(() => {
        const extractTextFromElement = (element) => {
            if (typeof element === 'string') {
                return element;
            } else if (element?.props && element?.props?.children) {
                if (Array.isArray(element?.props?.children)) {
                    return element?.props?.children.map(extractTextFromElement).join(' ');
                } else {
                    return extractTextFromElement(element?.props?.children);
                }
            }
            return '';
        };

        const nameElement = props?.data?.document_name;
        const nameText = extractTextFromElement(nameElement);
        setDocumentName(nameText);
        if (props.data) {
            setDocStatus(props.data.status);
        }
    }, [props?.data?.document_name]);

    const handleClose = () => setShow(false);
    const handleShow = (event) => {
        event.preventDefault();
        setShow(true);
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        try {
            const response = await _axios.patch(`${ServerPath}/document`, {
                tenant_id: "nagpur_001",
                doc_id: docId,
                document_name: DocumentName,
                status: docStatus, // Ensure status is not null
            });

            console.log(response.data);
            handleClose();
            window.location.reload(); // Reload the component
        } catch (error) {
            console.error(error);
        }
    };

    return (
        <>
            <Button onClick={handleShow} className="btn-square btn btn-primary mx-2"><i className='icon-pencil-alt'></i></Button>

            <Modal
                show={show}
                onHide={handleClose}
                backdrop="static"
                keyboard={false}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>Edit Document</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form onSubmit={handleSubmit}>
                        <Row>
                            <Form.Group as={Col} controlId='formGridDocumentName'>
                                <Form.Label>Document Name</Form.Label>
                                <Form.Control
                                    type='text'
                                    placeholder='Document Name'
                                    value={DocumentName}
                                    onChange={(e) => setDocumentName(e.target.value)}
                                />
                            </Form.Group>
                        </Row>
                        <Row>
                            <Form.Group as={Col} controlId='formGridStatus'>
                                <Form.Label>Status</Form.Label>
                                <Form.Control
                                    as="select"
                                    value={docStatus}
                                    onChange={(e) => setDocStatus(e.target.value)}
                                >
                                    <option value={1}>Active</option>
                                    <option value={0}>Inactive</option>
                                </Form.Control>
                            </Form.Group>
                        </Row>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        Close
                    </Button>
                    <Button form='AddDocForm' variant="primary" type='submit' onClick={handleSubmit}>Update</Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default EditTag;
